<template>
	<app-page>
		<app-heading title="Websites">
			<template v-slot:left>
				<app-button v-if="$ravello.can('website.post')"
					class="d-none d-sm-inline-flex"
					color="success"
					small
					outlined
					:to="{ name: 'website', params: { website: 'new' } }"
				>Add Website</app-button>
			</template>
		</app-heading>
		<app-row>
			<app-cell>
				<app-data-table
					:items="websites"
					:headers="headers"
					:total="count"
					:refresh.sync="refresh"
					@update="fetchWebsites"
				>
					<template v-slot:actions="{ item }">
						<app-button
							v-if="$ravello.can('website.get')"
							color="secondary"
							table
							@click="onManage(item._id)"
						>
							Manage
						</app-button>
						<app-button
							v-if="$ravello.can('website.put')"
							color="secondary"
							:to="{ name: 'website', params: { website: item._id } }"
							icon="fa-pencil-alt"
							table
						>
							Edit
						</app-button>
						<app-button-confirm
							v-if="$ravello.can('website.delete')"
							color="error"
							icon="fa-trash"
							table
							label-confirm="Remove"
							:description="`Are you sure you want to remove website <b>${item.name}</b>?`"
							title="Remove Website"
							@click="onDelete(item._id)"
						>
							Remove
						</app-button-confirm>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>
		<app-floating-button
			class="d-inline-flex d-sm-none"
			:to="{ name: 'website', params: { website: 'new' } }"
			color="success"
			icon="fa-plus"
		/>
	</app-page>
</template>

<script>
export default {
	data() {
		return {
			websites: [],
			count: -1,
			refresh: false,
			headers: [{
				text: 'Name',
				value: 'name',
				sortable: true,
			}, {
				text: 'Slug',
				value: 'slug',
				sortable: true,
			}, {
				text: 'Enterprise',
				value: 'enterprise.name',
				sortable: true,
			}, {
				text: 'Domain',
				value: 'domain',
				sortable: true,
			}, {
				text: 'Locales',
				value: 'locales',
				sortable: false,
				format: 'locales',
			}, {
				text: 'Currency',
				value: 'currency',
				sortable: true,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
		}
	},
	methods: {
		onManage(id) {
			this.$store.dispatch('app/setNav', false)
			this.$router.push({ name: 'website-pages', params: { website: id } })
		},
		async fetchWebsites(pagination) {
			const request = this.$ravello.graphql('websites')
				.fromPagination(pagination)
				.include(this.$ravello.graphql('enterprise').field('name'))
				.fields(['_id', 'name', 'slug', 'domain', 'locales', 'currency'])

			if (this.count === -1) {
				request.count('count')
			}
			try {
				this.websites = await request.query()
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},
		async onDelete(id) {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.v(2)
					.to('websites')
					.to(id)
					.delete()
				this.refresh = true
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},
	},
}
</script>
